<div class="branding-container">
  
  <!-- Header Section -->
  <div class="header-section">
    <div class="header-left">
      <button (click)="goBack()" class="back-btn">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="40" height="40" rx="20" fill="white" />
          <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="black" stroke-opacity="0.1" />
          <path d="M28 20H12M12 20L18 14M12 20L18 26" stroke="#131A26" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
      <div class="header-title">
        <div class="title-row">
          <h1>Watermarking</h1>
          <button *ngIf="!isEditMode" class="edit-btn mobile-edit-btn" (click)="enableEditMode()">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M18.5 2.50001C18.8978 2.10219 19.4374 1.87869 20 1.87869C20.5626 1.87869 21.1022 2.10219 21.5 2.50001C21.8978 2.89784 22.1213 3.4374 22.1213 4.00001C22.1213 4.56262 21.8978 5.10219 21.5 5.50001L12 15L8 16L9 12L18.5 2.50001Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Edit
          </button>
        </div>
        <p class="event-name">{{ eventName }}</p>
      </div>
    </div>
    <button *ngIf="!isEditMode" class="edit-btn desktop-edit-btn" (click)="enableEditMode()">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M18.5 2.50001C18.8978 2.10219 19.4374 1.87869 20 1.87869C20.5626 1.87869 21.1022 2.10219 21.5 2.50001C21.8978 2.89784 22.1213 3.4374 22.1213 4.00001C22.1213 4.56262 21.8978 5.10219 21.5 5.50001L12 15L8 16L9 12L18.5 2.50001Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Edit
    </button>
  </div>

  <!-- Main Card -->
  <div class="branding-card">
    
    <!-- Branding Toggle Section -->
    <div class="settings-section">
      <div class="section-header">
        <div class="section-info">
          <div class="section-title-row">
            <h2>Enable Watermarking</h2>
            <label class="modern-switch mobile-switch" [class.disabled]="!isEditMode">
              <input type="checkbox" [(ngModel)]="brandingEnabled" [disabled]="!isEditMode" (change)="onBrandingToggle($event)">
              <span class="switch-slider"></span>
            </label>
          </div>
          <p>Add a watermark to photos<br class="mobile-break">uploaded to this event</p>
        </div>
        <label class="modern-switch desktop-switch" [class.disabled]="!isEditMode">
          <input type="checkbox" [(ngModel)]="brandingEnabled" [disabled]="!isEditMode" (change)="onBrandingToggle($event)">
          <span class="switch-slider"></span>
        </label>
      </div>
    </div>

    <!-- Branding Configuration Section -->
    <div *ngIf="brandingEnabled" class="settings-section">
      <div class="section-header">
        <div class="section-info">
          <h2>Watermark Configuration</h2>
          <p>Customize your watermark text, logo, and position</p>
        </div>
      </div>

      <!-- Form Fields -->
      <div class="form-grid">
        
        <!-- Branding Text -->
        <div class="form-field">
          <label class="field-label">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 7V4H20V7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9 20H15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 4V20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Watermark Text
          </label>
          <input
            type="text"
            class="field-input"
            [(ngModel)]="brandingText"
            [disabled]="!isEditMode"
            placeholder="Enter your watermark text..."
          />
        </div>

        <!-- Logo Upload -->
        <div class="form-field">
          <label class="field-label">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <circle cx="8.5" cy="8.5" r="1.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M21 15L16 10L5 21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Watermark Logo
          </label>
          <div class="logo-upload-container">
            <input 
              type="file" 
              id="logoInput"
              accept="image/*" 
              [disabled]="!isEditMode"
              (change)="onLogoSelected($event)"
              style="display: none;"
            />
            <button 
              type="button" 
              class="upload-btn" 
              [disabled]="!isEditMode"
              (click)="triggerFileInput()"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M17 8L12 3L7 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 3V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              {{ logoUrl ? 'Change Logo' : 'Upload Logo' }}
            </button>
            <div class="logo-preview-container" *ngIf="prevLogo != 'null' && logoUrl">
              <img [src]="logoUrl" alt="Logo Preview" class="logo-preview-img">
              <button 
                type="button" 
                class="remove-logo-btn" 
                [disabled]="!isEditMode"
                (click)="removeLogo()"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
          <small class="field-hint">Maximum size: 500KB, Recommended: 800x800px</small>
        </div>

        <!-- Position Selector -->
        <div class="form-field">
          <label class="field-label">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Watermark Position
          </label>
          <select 
            class="field-select"
            [(ngModel)]="brandingPosition"
            [disabled]="!isEditMode"
          >
            <option value="bottom-right">Bottom Right</option>
            <option value="bottom-left">Bottom Left</option>
            <option value="top-right">Top Right</option>
            <option value="top-left">Top Left</option>
            <option value="center">Center</option>
          </select>
        </div>
      </div>
    </div>

    <!-- Preview Section -->
    <div *ngIf="brandingEnabled" class="settings-section preview-section">
      <div class="section-header">
        <div class="section-info">
          <h2>Preview</h2>
          <p>See how your branding will appear on photos</p>
        </div>
      </div>
      
      <div class="preview-grid">
        <!-- Landscape Preview -->
        <div class="preview-card">
          <div class="preview-label">Landscape</div>
          <div class="preview-image landscape">
            <img [src]="defaultLandscape" alt="Landscape preview" />
            <div class="watermark" [ngClass]="brandingPosition">
              <div class="branding-stack">
                <img *ngIf="prevLogo != 'null' && logoUrl != ''" [src]="logoUrl" alt="Logo" />
                <span *ngIf="brandingText">{{ brandingText }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Portrait Preview -->
        <div class="preview-card">
          <div class="preview-label">Portrait</div>
          <div class="preview-image portrait">
            <img [src]="defaultPortrait" alt="Portrait preview" />
            <div class="watermark" [ngClass]="brandingPosition">
              <div class="branding-stack">
                <img *ngIf="prevLogo != 'null' && logoUrl != ''" [src]="logoUrl" alt="Logo" />
                <span *ngIf="brandingText">{{ brandingText }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons">
      <button 
        class="btn btn-secondary" 
        *ngIf="isEditMode"
        (click)="cancelEdit()"
      >
        Cancel
      </button>
      <button 
        class="btn btn-primary" 
        *ngIf="isEditMode"
        (click)="saveBranding()"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16L21 8V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M17 21V13H7V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M7 3V8H15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Save Changes
      </button>
      <button 
        class="btn btn-outline" 
        *ngIf="!isEditMode"
        (click)="goToEventGallery()"
      >
        View Event Gallery
      </button>
    </div>

  </div>

  <!-- Loading Overlay -->
  <div class="overlay" *ngIf="isLoading">
    <div class="spinner"></div>
  </div>

  <!-- Confirmation Modal -->
  <app-confirmation-modal 
    *ngIf="showConfirmModal" 
    [isHomePage]="false" 
    [confirmMessage]="confirmMessage"
    (confirmed)="onChangeConfirmed($event)" 
    (cancel)="onCancel($event)">
  </app-confirmation-modal>

</div>